//#region src/extensions/font-size-extension/utils/font-size.tsx
var e = [
	8,
	9,
	10,
	11,
	12,
	13,
	14,
	15,
	16,
	17,
	18,
	20,
	22,
	24,
	26,
	28,
	30,
	34,
	38,
	42,
	46,
	50,
	58,
	64,
	72,
	80,
	88,
	96
], t = () => e.map((e) => {
	let t = `${e}px`;
	return {
		value: t,
		label: t
	};
});
//#endregion
export { t as getFontSizeValues };
